import pick from "lodash/pick";
export var getCommonImageProps = function (props) {
    return pick(props, [
        "mobileOptions",
        "theme",
        "questionKey",
        "cardStyles",
        "gridConfiguration",
        "titleOnImage",
        "subTitleOnImage",
        "blackBackgroundOnTitle",
        "svgFillColor",
        "svgStrokeColor",
        "svgBackgroundColor",
        "svgDimensions",
        "avatarOnTopLayout",
        "mobileSvgWidth",
    ]);
};
